import {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {usePageProps} from 'context/unsafePageProps'
import {toggle} from 'opticks'

import {trackEvent} from '@daedalus/core/src/analytics/modules/actions'
import {
  Action,
  Category,
  Entity
} from '@daedalus/core/src/analytics/types/Events'

/**
 * Track experiments that were decided in the lambda on the client side
 * This also checks for mismatches between the client and server decisions (potentially due to different contexts)
 */
export const TrackSSRExperiments = () => {
  const {experiments} = usePageProps()

  const dispatch = useDispatch()
  useEffect(() => {
    if (!experiments) {
      dispatch(
        trackEvent({
          category: Category.System,
          entity: Entity.Experiment,
          action: Action.Missing
        })
      )
      return
    }

    for (const key in experiments) {
      const experimentSide = toggle(key, 'a', 'b') // eslint-disable-line opticks/toggle
      if (experimentSide !== experiments[key]) {
        dispatch(
          trackEvent({
            category: Category.System,
            entity: Entity.Experiment,
            action: Action.Mismatched,
            payload: {
              experiment: key
            }
          })
        )
      }
    }
  }, [dispatch, experiments])

  return null
}
